export default __webpack_public_path__ + "static/media/16.96af9506.png";